module.exports = __webpack_public_path__ + "img/img-a3ecb6af.9887a6df.png";